import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import HomeDropDown from "../components/HomeDropDown";
import { getPortalConfig } from "../config";

const Profile = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();
    const portalConfig = getPortalConfig();

    return (
        <div className="flex flex-col h-screen">
            {/* Header (Fixed at the top) */}
            <div className="fixed top-0 left-0 w-full z-50 bg-primary">
                <Header />
            </div>

            {/* Main Layout (Sidebar + Content) */}
            <div className="flex flex-1 mt-[72px]">
                {/* Sidebar (Fixed and non-scrollable) */}
                <div className="fixed left-0 w-64 bg-white shadow-md h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
                    <Sidebar />
                </div>

                {/* Main Content Area (Scrollable) */}
                <main className="flex-1 p-6 w-50 bg-gray-100 overflow-y-auto mt-[25px] lg:ml-64">
                    <HomeDropDown />
                    {portalConfig?.name === "TERO" && (
                        <div className="w-full text-center py-2 text-xs text-gray-500 mt-4">
                            © {currentYear} Tribal D, Inc.
                        </div>
                    )}
                </main>
            </div>
        </div>
    );
};

export default Profile;